import { defaultSkillData } from '../../../../backend/config/classifiers/defaults/DefaultSkillData';
import { skillSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers, allowManageSkillsAndTrainingsClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const skillEntityName = 'skill';
const skillColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { type: {
        type: 'string-required',
        index: true,
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineSkillClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: skillColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { type: params.data.type, search: [params.data.name, params.data.status, params.data.type].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState) && !allowManageSkillsAndTrainingsClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultSkillData,
        defaultNameChanges: [{ from: 'Clerical Work', to: 'Other' }],
        publicData: [
            {
                classifierName: 'healthcareSkill',
                listRequest: {
                    filter: [
                        { column: 'type', op: '=', value: 'healthcare' },
                        { column: 'status', op: '=', value: 'active' },
                    ],
                    orderBy: [{ column: 'name' }],
                },
            },
            {
                classifierName: 'otherSkill',
                listRequest: {
                    filter: [
                        { column: 'type', op: '=', value: 'other' },
                        { column: 'status', op: '=', value: 'active' },
                    ],
                    orderBy: [{ column: 'name' }],
                },
            },
            {
                classifierName: 'skill',
                listRequest: {
                    filter: [{ column: 'status', op: '=', value: 'active' }],
                    orderBy: [{ column: 'name' }],
                },
            },
        ],
    }, skillSchema);
}
